export const messages = {
  en: {
    feeComboMemberManage: {
      title: 'Fee Items',
      feeType: 'Fee Type',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      paymentType: 'Payment Type',
      paymentCycle: 'Payment Cycle',
      unitPrice: 'Unit Price',
      additionalFee: 'Additional/Fixed Fee',
      prepay: 'Prepay',
      postpay: 'Postpay',
      back: 'Back',
      selectFeeType: 'Please select fee type',
      selectFeeItem: 'Please select fee item',
      feeTypeRequired: 'Fee type is required',
      feeItemRequired: 'Fee item is required',
      confirmDelete: 'Confirm to delete this fee combo member?',
      addSuccess: 'Add fee combo member successfully',
      deleteSuccess: 'Delete fee combo member successfully',
      fetchError: 'Failed to fetch fee combo members',
      fetchDictError: 'Failed to fetch dictionary data',
      fetchFeeConfigError: 'Failed to fetch fee configs',
      addFailed: 'Failed to add fee combo member',
      deleteFailed: 'Failed to delete fee combo member'
    }
  },
  zh: {
    feeComboMemberManage: {
      title: '费用项',
      feeType: '费用类型',
      feeItem: '收费项目',
      feeFlag: '费用标识',
      paymentType: '付费类型',
      paymentCycle: '缴费周期',
      unitPrice: '计费单价',
      additionalFee: '附加/固定费',
      prepay: '预付费',
      postpay: '后付费',
      back: '返回',
      selectFeeType: '请选择费用类型',
      selectFeeItem: '请选择收费项目',
      feeTypeRequired: '费用类型不能为空',
      feeItemRequired: '收费项目不能为空',
      confirmDelete: '确定删除该费用套餐成员?',
      addSuccess: '添加费用套餐成员成功',
      deleteSuccess: '删除费用套餐成员成功',
      fetchError: '获取费用套餐成员失败',
      fetchDictError: '获取字典数据失败',
      fetchFeeConfigError: '获取费用配置失败',
      addFailed: '添加费用套餐成员失败',
      deleteFailed: '删除费用套餐成员失败'
    }
  }
}